import React from 'react';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import Tooltip from '@material-ui/core/Tooltip';
import { labelHelper } from '../../../../../helpers/labelHelper';
import './Inheritage.css';

export const InheritedSymbol = ({ size }) => {
    return (
        <Tooltip title={labelHelper.getLabel('IsInheritedFromParentEvent')}>
            <div className="inherited-symbol">
            <AccountTreeIcon style={{ fontSize: "17px", color: 'rgb(23, 162, 184)' }} />
            </div>
        </Tooltip >
    )
}